import { Routes } from "@angular/router";
import { DashboardComponent } from "./shared/layouts/dashboard/dashboard.component";
import { AuthGuard } from "./shared/services/guard.service";

export const APP_ROUTES: Routes = [
  // {
  //   path: "authentication",
  //   loadChildren: () =>
  //     import("./modules/authentication/auth.routes").then((m) => m.AUTH_ROUTES),
  // },
  {
    path: "",
    canActivate: [],
    component: DashboardComponent,
    children: [],
  },
];
